import React from "react"
import { useSelector } from "react-redux"

import { selectContactSubscriptions } from "@root/store/selectors"
import { useAppDispatch } from "@root/store"
import {
  loadContactSubscriptions,
  subscribeContact,
  unsubscribeContact,
} from "@root/store/thunks"
import Subscriptions from "@root/components/Subscriptions"
import { Scope } from "@ua/web-sdk/lib/remote-data/preference-center"
import { contactToSubscriptionList } from "@root/store/utils"

const ContactSubscriptions: React.FC = () => {
  const dispatch = useAppDispatch()
  const lists = useSelector(selectContactSubscriptions)

  const addList = React.useCallback(
    (listId: string, scope: Scope) =>
      dispatch(subscribeContact({ listId, scope })),
    [dispatch]
  )

  const removeList = React.useCallback(
    (listId: string, scope: Scope) =>
      dispatch(unsubscribeContact({ listId, scope })),
    [dispatch]
  )

  React.useEffect(() => {
    dispatch(loadContactSubscriptions())
  }, [dispatch])

  return (
    <Subscriptions
      type="contact"
      lists={contactToSubscriptionList(lists)}
      onAddList={addList}
      onRemoveList={removeList}
    />
  )
}

export default ContactSubscriptions
